import { Flex } from 'components/base/layout-components';
import { StyledProviderName } from './GitProvidierSelect.style';

interface ProviderButtonContentProps {
  logo: React.ReactElement;
  name: string;
  isSelected: boolean;
}

export function ProviderButtonContent({
  logo,
  name,
  isSelected
}: ProviderButtonContentProps) {
  return (
    <Flex position='relative' direction='column' items='center'>
      <Flex width='4rem' height='4rem' items='center' justify='center'>
        {logo}
      </Flex>
      <StyledProviderName isSelected={isSelected}>{name}</StyledProviderName>
    </Flex>
  );
}
